import { Phone, Mail, MapPin, Clock } from "lucide-react";

const items = [
  {
    icon: Phone,
    label: "Call or Text",
    value: "(506) 608-4350",
    href: "tel:+15066084350",
    id: "contact-phone",
  },
  {
    icon: Mail,
    label: "Email",
    value: "stevenunderhill40@gmail.com",
    href: "mailto:stevenunderhill40@gmail.com",
    id: "contact-email",
  },
  {
    icon: MapPin,
    label: "Based In",
    value: "Saint John, NB",
    href: "#area",
    id: "contact-location",
  },
  {
    icon: Clock,
    label: "Hours",
    value: "Mon–Sat · 7AM – 8PM",
    href: "#",
    id: "contact-hours",
  },
];

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 border-b border-[#2A2A2A]"
    >
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
        <div className="lg:col-span-8">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#FFD600]">
            06 — Get In Touch
          </span>
          <h2 className="font-display font-bold uppercase tracking-tight leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mt-4">
            Pick up the
            <br />
            phone. <span className="text-[#00E5FF]">We answer.</span>
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <a
              key={i}
              href={it.href}
              data-testid={it.id}
              className="bg-[#0A0A0A] hover:bg-[#FFD600] group transition-colors p-8 md:p-10 block"
            >
              <Icon
                size={26}
                className="text-[#FFD600] group-hover:text-black transition-colors"
              />
              <div className="text-[10px] uppercase tracking-[0.3em] text-gray-500 group-hover:text-black/70 mt-6">
                {it.label}
              </div>
              <div className="font-display font-bold uppercase text-xl md:text-2xl mt-2 leading-tight group-hover:text-black">
                {it.value}
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}
